import BasicSelector from './basic-selector.vue';

export default {
  install(application) {
    application.component('yx-basic-selector', BasicSelector);
  },
};
